import React, { useState } from "react";
import "./Login.css";
import GradientButton from "../../components/button/Button";
import { Logo } from "../../images/Images";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import LoadingComponent from "../../components/loading/Loading";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const payload = {
    email: email,
  };

  const handleClick = async () => {
    setLoading(true);

    try {
      console.log(payload);

      const res = await axiosInstance.put("/auth/forgot-password", payload);
      if (res.data) {
        setLoading(false);

        toast.success(res.data.message);
        localStorage.setItem("forgot_id", res.data.data.id);

        setTimeout(() => {
          setLoading(false);
          window.location.href = "/create-password";
        }, 3000);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error.response.data.message);
      toast.error(error.response.data.message);
    }
  };

  if (loading) {
    return <LoadingComponent />;
  }
  return (
    <div className="login-page">
      {/* Left-side Image */}
      <div className="login-page__image">
        <img
          src="https://img.freepik.com/free-photo/top-view-vegetables-fruits-zucchini-bell-peppers-apples-quince-cherry-tomatoes-cumcuat-parsley-cabbage-lemon-pomegranates_140725-59438.jpg?uid=R27806234&ga=GA1.1.1852762410.1725342281&semt=ais_hybrid"
          alt="Fresh Produce"
        />
      </div>

      {/* Right-side Form */}
      <div className="login-page__form-container">
        <form className="login-page__form">
          <div className="login-page__title">
            <img src={Logo} alt="logo" />
          </div>
          <h2 className="login-page__subtitle">Forgot Password?</h2>
          <p className="login-page__description">
            Enter your Registered Email Address
          </p>

          {/* Input Fields */}
          <div className="login-page__input-group" style={{ marginTop: 10 }}>
            <label>Email Address</label>
            <input
              type="email"
              placeholder="E.g JohnDoe@gmail.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="gd-btn">
            <GradientButton text="Send OTP" onClick={handleClick} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
